// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2h3z9","image":"Header_image__2W47I","name":"Header_name__3s3hY","info":"Header_info__1QtyN","infoRow":"Header_infoRow__1b4kU"};